module.exports = __webpack_public_path__ + "static/img/l-4.4bef1bc1.png";